import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #171717;
`;

export const Wrapper = styled.div`
    width: 70%;
    background-color: #1c1c1c;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    @media (max-width: 1024px) {
        width: 80%;
        padding: 1.5rem;
    }

    @media (max-width: 600px) {
        width: 95%;
        padding: 1rem;
    }
`;

export const MessageBox = styled.div`
    overflow: hidden;
    border-radius: 20px;
    text-align: center;

    img {
        width: 100%;
    }

    @media (max-width: 1024px) {
        font-size: 1.2rem;
        padding: 1.5rem;
    }

    @media (max-width: 600px) {
        font-size: 1rem;
        padding: 1rem;
    }
`;

export const PhoneBox = styled.div`
    position: relative;
    top: -120px;
    font-size: 3rem;
    text-align: center;

    span {
        font-weight: bold;
    }

    @media (max-width: 600px) {
        font-size: 1rem;
    }
`;

export const ErrorBox = styled.div`
    position: relative;
    top: -85px;
    font-size: 3rem;
    text-align: center;

    span {
        font-weight: bold;
    }

    @media (max-width: 600px) {
        font-size: 1rem;
    }
`;

export const InputBox = styled.div`
    margin-top: 1rem;
    padding: 0.8rem 1.2rem;
    border-radius: 10px;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    label {
        font-weight: bold;
        white-space: nowrap;
    }

    input {
        flex: 1;
        border: none;
        outline: none;
        border-radius: 10px;
        font-size: 1.5rem;
        background: black;
        color: white;
        margin-left: 3rem;
        height: 55px;
        padding-left: 15px;
    }

    @media (max-width: 600px) {
        font-size: 1rem;
        input {
            font-size: 1rem;
        }
    }
`;

export const ConfirmButton = styled.button`
    display: block;
    margin: 2rem auto 0;
    padding: 0.8rem 2rem;
    border-radius: 10px;
    color: white;
    background-color: #007bff;
    font-size: 1.2rem;
    cursor: pointer;

    @media (max-width: 600px) {
        font-size: 1rem;
    }
`;
